// covered-by: frontends/carrie/src/ask-v2/home/__tests__/greeting.test.ts
import { type AskPunttBriefing } from "@mg/schemas/src/christo/askPunttBriefing";

export function firstName(name: string | undefined | null): string {
  const trimmed = name?.trim();
  if (!trimmed) return "";
  return trimmed.split(/\s+/)[0] ?? "";
}

export function greetingNameSuffix(name: string | undefined | null): string {
  const first = firstName(name);
  return first ? ` ${first}` : "";
}

export function briefingGreetingText(
  briefing: AskPunttBriefing | undefined,
): string | null {
  const greeting = briefing?.greeting?.trim();
  return greeting ? greeting : null;
}
